import React, { FC } from "react";
import { useIntl } from "react-intl";

import { ADD_MODE, EDIT_MODE, READ_MODE, EntityFormHeaderTitle } from "../../../../common/entity-form";

type CompensationProcedureFormHeaderTitleProps = {
    compensationProcedureId: string;
    mode: string;
    onBackClick: () => void;
};

const CompensationProcedureFormHeaderTitle: FC<CompensationProcedureFormHeaderTitleProps> = ({ compensationProcedureId, mode, onBackClick }) => {
    const intl = useIntl();

    const titleValues = { compensationProcedureId: compensationProcedureId };

    const titleMap = {
        [ADD_MODE]: intl.formatMessage({ id: "compensation-procedure-form-page-header.new.title" }),
        [EDIT_MODE]: intl.formatMessage({ id: "compensation-procedure-form-page-header.edit.title" }, titleValues),
        [READ_MODE]: intl.formatMessage({ id: "compensation-procedure-form-page-header.read.title" }, titleValues),
    };

    return <EntityFormHeaderTitle title={titleMap[mode]} onBackClick={onBackClick} />;
};

export default CompensationProcedureFormHeaderTitle;
